/*
 * CreaRocket · Marchés & devises (chantier 1, 03/11/2026). Chargé (defer) seulement si le réglage thème
 * « CreaRocket · Marchés » cr_marches_actifs est coché (snippet cr-prix, tete: true). Sans dépendance.
 *
 * Marché = pays. TN → TND (fr) · UE/EEE + GB + CH → EUR (fr) · QA → QAR, SA → SAR, AE → AED (en) · autres → USD (en).
 * Parité : le nombre ne change jamais, seule la devise change (5 TND → 5,00 € / €5.00 / $5.00 / 5.00 QAR). Aucun taux.
 * Tunisie : ce module ne touche à rien (ni texte, ni bouton, ni panier, ni checkout).
 * Hors Tunisie : prix réécrits (éléments <cr-prix>, puis montants « N TND » écrits en dur ou par script), checkout
 * Shopify jamais proposé (boutons masqués par le CSS du <head>, accès interceptés) et remplacé par « Payer par carte »
 * (désactivé tant que le réglage cr_ls_checkout_url est vide) et « Commander par virement » (masqué tant que
 * cr_virement_webhook est vide ; POST JSON vers ce webhook n8n). Le paiement en jetons reste inchangé.
 * Stockage navigateur : localStorage « cr-market » = { country, currency, lang, v: 1, explicit: true }, écrit seulement
 * par le bouton de confirmation de la fenêtre pays (aucune donnée personnelle). Échap / fermeture : rien n'est écrit.
 * Recette : ?cr-market=XX force le pays pour la session (sessionStorage, jamais localStorage), ?cr-market=reset efface.
 * Détection (QA 03/11) : tout signal tunisien (pays Shopify TN, fuseau Africa/Tunis, langue *-TN) → TN.
 */
(function (root) {
  'use strict';

  var KEY = 'cr-market';
  var EUR = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE IS LI NO GB CH'.split(' ');
  var GOLFE = { QA: 'QAR', SA: 'SAR', AE: 'AED' };
  var NOMS = { TND: 'dinars tunisiens', EUR: 'euros', USD: 'dollars américains', QAR: 'riyals qataris', SAR: 'riyals saoudiens', AED: 'dirhams des Émirats' };
  var NOMS_COURTS = { TND: 'dinars', EUR: 'euros', USD: 'dollars', QAR: 'riyals', SAR: 'riyals', AED: 'dirhams' };

  function norm(cc) {
    cc = String(cc || '').trim().toUpperCase();
    if (cc === 'UK') cc = 'GB';
    return /^[A-Z]{2}$/.test(cc) ? cc : '';
  }

  /** Pays → { country, currency, lang }. Pays inconnu ou vide → ZZ, USD, en. */
  function marketFor(cc) {
    cc = norm(cc) || 'ZZ';
    if (cc === 'TN') return { country: 'TN', currency: 'TND', lang: 'fr' };
    if (EUR.indexOf(cc) >= 0) return { country: cc, currency: 'EUR', lang: 'fr' };
    if (GOLFE[cc]) return { country: cc, currency: GOLFE[cc], lang: 'en' };
    return { country: cc, currency: 'USD', lang: 'en' };
  }

  /** Signal tunisien dans les langues du navigateur (fr-TN, ar-TN…). */
  function langTN(langs) {
    return /-TN/i.test([].concat(langs || []).join(','));
  }

  /**
   * Détection (même ordre que le script inline du <head>). Principe QA 03/11 : tout signal tunisien → TN ; seul un
   * choix explicite confirmé dans la fenêtre prime. o = { param, stored, tz, shopify, lang, langs }
   */
  function detect(o) {
    o = o || {};
    var p = norm(o.param);
    if (p) return { country: p, src: 'param' };
    var s = o.stored;
    if (s && s.v === 1 && s.explicit === true && norm(s.country)) return { country: norm(s.country), src: 'choix' };
    var sh = norm(o.shopify);
    if (sh === 'TN' || o.tz === 'Africa/Tunis' || langTN([o.lang].concat(o.langs || []))) return { country: 'TN', src: 'tn' };
    if (sh) return { country: sh, src: 'shopify' };
    var r = norm(String(o.lang || '').split('-')[1]);
    if (r) return { country: r, src: 'langue' };
    return { country: 'ZZ', src: 'defaut' };
  }

  function readStore(st) {
    try {
      var x = JSON.parse(st.getItem(KEY));
      if (x && x.v === 1 && x.explicit === true && norm(x.country)) return x;
    } catch (e) {}
    return null;
  }

  /** Seul appel : bouton « Confirmer / Enregistrer » de la fenêtre pays (choix explicite). */
  function writeStore(st, cc) {
    var m = marketFor(cc);
    var o = { country: m.country, currency: m.currency, lang: m.lang, v: 1, explicit: true };
    try { st.setItem(KEY, JSON.stringify(o)); } catch (e) {}
    return o;
  }

  function groupe(ent, sep) {
    return String(ent).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  /** Montant (nombre, dans l'unité de la devise) → texte. Chiffres latins, 2 décimales hors TND. */
  function format(n, cur, lang) {
    n = Number(n) || 0;
    var neg = n < 0;
    var c = Math.round(Math.abs(n) * 100);
    var ent = Math.floor(c / 100);
    var dec = String(c % 100);
    if (dec.length < 2) dec = '0' + dec;
    var s;
    if (cur === 'EUR' && lang === 'fr') s = groupe(ent, ' ') + ',' + dec + ' €';
    else if (cur === 'EUR') s = '€' + groupe(ent, ',') + '.' + dec;
    else if (cur === 'USD') s = '$' + groupe(ent, ',') + '.' + dec;
    else s = groupe(ent, ',') + '.' + dec + ' ' + cur;
    return (neg ? '−' : '') + s;
  }

  /** « 1 250 », « 7,143 », « 25 » (écriture de la boutique : espace pour les milliers, virgule décimale) → nombre */
  function parseAmount(t) {
    t = String(t).replace(/[\s  ]/g, '');
    var m = t.match(/^(\d+)(?:[.,](\d{1,3}))?$/);
    if (!m) return NaN;
    return Number(m[1] + (m[2] ? '.' + m[2] : ''));
  }

  var RE_MONTANT = /(\d{1,3}(?:[   ]\d{3})+|\d+)(?:[.,](\d{1,3}))?[   ]?TND\b/g;

  /** Réécrit les montants et libellés « TND » / « dinars » d'un texte pour un marché (hors TN). */
  function convertText(s, mk) {
    if (!s || mk.currency === 'TND' || !/TND|dinar/i.test(s)) return s;
    s = s.replace(RE_MONTANT, function (all, ent, dec) {
      var n = parseAmount(ent + (dec ? ',' + dec : ''));
      return isNaN(n) ? all : format(n, mk.currency, mk.lang);
    });
    s = s.replace(/\bTND\b/g, mk.currency);
    s = s.replace(/dinars tunisiens/g, NOMS[mk.currency]);
    s = s.replace(/\bdinars\b/g, NOMS_COURTS[mk.currency]);
    s = s.replace(/\bdinar\b/g, NOMS_COURTS[mk.currency].replace(/s$/, ''));
    return s;
  }

  /**
   * Q-12 (Alaa 03/11 22:58) : le minimum de paiement en argent (20) ne vaut qu'en Tunisie. Hors TN, toute phrase de
   * contenu qui l'annonce est retirée du texte AVANT la conversion de devise (sinon « 20 TND » deviendrait « 20,00 € ») :
   * phrase crea-grille [[paiement]] / [[paiement_avant]] (« Carte bancaire, virement ou dépôt en banque pour toute commande
   * à partir de 20 TND ; en dessous, on paie en jetons. »), [[seuil_tnd]] saisi dans les templates (« Le paiement en argent
   * se fait à partir de 20 TND, … »), « Paiement en argent à partir de 20 TND. Pour ce fichier seul, … », « Minimum de
   * commande : 20 TND ». Une phrase = jusqu'au point final ; « sans minimum » (jetons) n'est pas visé.
   */
  var RE_MIN = /[^.!?]*?(?:paiement en argent|pour toute commande à partir de|minimum de (?:commande|paiement)|minimum de \d+[ \u00a0\u202f]?TND)[^.!?]*?\d+(?:[.,]\d+)?[ \u00a0\u202f]?TND\b[^.!?]*(?:[.!?](?:[ \u00a0\u202f]*Pour ce fichier seul, utilisez vos jetons\.)?|$)[ \u00a0\u202f]*/gi;
  var RE_MIN_AVANT = /Carte bancaire, virement ou dépôt en banque pour toute commande à partir de \d+[ \u00a0\u202f]?TND ; en dessous,[ \u00a0\u202f]*/gi;
  function sansMinimumTexte(s) {
    if (!s || !/TND/.test(s)) return s;
    var r = s.replace(RE_MIN, '').replace(RE_MIN_AVANT, '');
    return r === s ? s : r.replace(/^[ \u00a0\u202f]+/, s.match(/^[ \u00a0\u202f]*/)[0]);
  }

  /** « /cart/123:1,456:2?discount=… » → [{ variant_id, quantity }] */
  function itemsFromPermalink(path) {
    var m = String(path || '').match(/^\/cart\/(\d+:\d+(?:,\d+:\d+)*)/);
    if (!m) return null;
    return m[1].split(',').map(function (x) {
      var p = x.split(':');
      return { variant_id: p[0], quantity: Number(p[1]) || 1 };
    });
  }

  var API = {
    KEY: KEY, EUR: EUR, marketFor: marketFor, detect: detect, readStore: readStore, writeStore: writeStore,
    langTN: langTN, format: format, parseAmount: parseAmount, convertText: convertText, sansMinimumTexte: sansMinimumTexte, itemsFromPermalink: itemsFromPermalink
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = API; return; }
  if (typeof document === 'undefined') return;

  // ------------------------------------------------------------------ navigateur
  var d = document.documentElement;
  var me = document.currentScript;
  var CFG = {
    wh: (me && me.getAttribute('data-wh')) || '',
    ls: (me && me.getAttribute('data-ls')) || '',
    u: Number(me && me.getAttribute('data-u')) || 100,
    ed: !!(me && me.hasAttribute('data-ed')),
    c: (me && me.getAttribute('data-c')) || ''
  };
  var ST = null;
  try { ST = root.localStorage; ST.getItem(KEY); } catch (e) { ST = null; }
  function sess(k) { try { return root.sessionStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function tz() { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return ''; } }

  /**
   * Filet QA B3 : marché lu sur <html data-market> ; s'il est absent (script inline interrompu) ou si le stockage est
   * indisponible, détection complète refaite ici avec les mêmes règles (signaux tunisiens prioritaires). Sans marché
   * déterminé, rien n'est intercepté (comportement d'aujourd'hui).
   */
  function marcheCourant() {
    var cc = norm(d.getAttribute('data-market'));
    if (cc && ST) return { cc: cc, src: root.crMarketSrc || '' };
    var nv = root.navigator || {};
    var p = '';
    try { p = new URLSearchParams(location.search).get(KEY) || ''; } catch (e) {}
    var r = detect({ param: norm(p) || norm(sess(KEY)), stored: ST ? readStore(ST) : null, tz: tz(), shopify: CFG.c, lang: nv.language || '', langs: nv.languages || [] });
    if (cc && cc !== r.country) cc = r.country === 'TN' || cc === 'TN' ? 'TN' : cc; // désaccord : TN l'emporte
    else cc = r.country;
    try { d.setAttribute('data-market', cc); } catch (e) {}
    return { cc: cc, src: r.src };
  }

  var pret = function () { d.removeAttribute('data-cr-attente'); };
  try {
    // ?cr-market=XX (recette) : lu et rangé en sessionStorage par le script inline du <head>, jamais en localStorage.
    var mc = marcheCourant();
    var cc = mc.cc;
    var src = mc.src;
    if (!cc) { pret(); return; } // marché indéterminé : aucune interception
    var MK = marketFor(cc);
    var L = MK.lang === 'en';
    API.market = MK;
    root.crMarket = API;
    if (MK.currency === 'TND') return; // Tunisie : rien ne change.
    demarrer(MK, L, src);
  } catch (err) {
    pret();
    try { d.setAttribute('data-market', 'TN'); } catch (e) {} // erreur : retour au comportement tunisien (checkout visible)
  }

  function demarrer(MK, L, src) {
    var T = L
      ? { carte: 'Pay by card', bientot: 'Coming soon', vir: 'Order by bank transfer', mail: 'Your e-mail address', envoyer: 'Get the transfer details', annuler: 'Close', titre: 'Pay for your order', min: 'Minimum order not reached.', ok: 'Order recorded.', e400: 'Please check your e-mail address and your cart.', e400v: 'An item is no longer available. Please update your cart.', e503: 'Service temporarily unavailable. Please try again later.', e502: 'The shop could not record your order. Please try again.', eres: 'Network error. Please try again.', tokens: 'Token payment is still available on each product page.', attendre: 'Please wait a few seconds before trying again.', gratuit: 'Free downloads outside Tunisia are coming soon. Sign in to use your tokens.', pays: 'Country', modif: 'change', accueil: 'Welcome to CreaRocket', detecte: 'We detected your country:', confirmer: 'Confirm', changer: 'Choose another country', valider: 'Save', autre: 'Other country', prix: 'Prices are shown in' }
      : { carte: 'Payer par carte', bientot: 'Bientôt disponible', vir: 'Commander par virement', mail: 'Votre adresse e-mail', envoyer: 'Recevoir les coordonnées du virement', annuler: 'Fermer', titre: 'Régler votre commande', min: 'Minimum de commande non atteint.', ok: 'Commande enregistrée.', e400: 'Vérifiez votre adresse e-mail et votre panier.', e400v: "Un article n'est plus disponible. Mettez votre panier à jour.", e503: 'Service momentanément indisponible. Réessayez un peu plus tard.', e502: "La boutique n'a pas pu enregistrer la commande. Réessayez.", eres: 'Erreur réseau. Réessayez.', tokens: 'Le paiement en jetons reste disponible sur chaque fiche.', attendre: 'Patientez quelques secondes avant de réessayer.', gratuit: 'Le téléchargement gratuit hors Tunisie arrive bientôt. Connectez-vous pour utiliser vos jetons.', pays: 'Pays', modif: 'modifier', accueil: 'Bienvenue sur CreaRocket', detecte: 'Nous avons détecté votre pays :', confirmer: 'Confirmer', changer: 'Choisir un autre pays', valider: 'Enregistrer', autre: 'Autre pays', prix: 'Prix affichés en' };

    var nomPays = function (c) {
      if (c === 'ZZ') return T.autre;
      try { return new Intl.DisplayNames([MK.lang], { type: 'region' }).of(c) || c; } catch (e) { return c; }
    };

    // ---------- styles (hors Tunisie seulement) ----------
    var css = document.createElement('style');
    css.textContent =
      '.cr-mk-ctas{display:grid;gap:8px;margin-top:8px}.cr-mk-btn{display:flex;align-items:center;justify-content:center;gap:6px;width:100%;min-height:44px;padding:10px 16px;border-radius:var(--style-border-radius-buttons-primary,10px);border:2px solid #1e1b3a;background:#1e1b3a;color:#fff;font:inherit;font-weight:700;cursor:pointer;text-decoration:none}' +
      '.cr-mk-btn--alt{background:#fff;color:#1e1b3a}.cr-mk-btn[disabled],.cr-mk-btn[aria-disabled=true]{opacity:.55;cursor:not-allowed}.cr-mk-btn small{font-weight:600;opacity:.85}' +
      '.cr-mk-note{margin:4px 0 0;font-size:13px;line-height:1.4;color:#3d3a52}.cr-mk-err{color:#b3261e}.cr-mk-ins{white-space:pre-wrap;margin:8px 0 0;padding:12px;border-radius:10px;background:#f4f2fa;font-size:14px;line-height:1.5}' +
      '.cr-mk-dlg{max-width:min(440px,calc(100vw - 32px));width:100%;padding:20px;border:0;border-radius:16px;box-shadow:0 20px 60px rgba(0,0,0,.25);color:#1e1b3a}.cr-mk-dlg::backdrop{background:rgba(20,18,40,.5)}' +
      '.cr-mk-dlg h2{margin:0 0 8px;font-size:20px}.cr-mk-dlg label{display:block;margin:10px 0 4px;font-weight:700;font-size:14px}.cr-mk-dlg input,.cr-mk-dlg select{width:100%;min-height:44px;padding:8px 10px;border:1.5px solid #c9c5d8;border-radius:10px;font:inherit}' +
      '.cr-mk-row{display:flex;gap:8px;margin-top:14px;flex-wrap:wrap}.cr-mk-row>*{flex:1 1 140px}.cr-mk-foot{margin:8px 0;font-size:13px}.cr-mk-foot button{background:none;border:0;padding:0;color:inherit;text-decoration:underline;cursor:pointer;font:inherit}';
    document.head.appendChild(css);

    // ---------- prix ----------
    var IGN = /^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT|TEMPLATE|INPUT|CODE|PRE)$/;
    function prix(el) {
      var a = el.getAttribute('data-cr-m');
      if (a !== null && a !== '' && !isNaN(Number(a))) {
        var cible = format(Number(a) / CFG.u, MK.currency, MK.lang);
        if (el.textContent !== cible) el.textContent = cible; // garde : pas de boucle avec l'observateur
      }
      if (!el.hasAttribute('data-cr-ok')) el.setAttribute('data-cr-ok', '');
      // « {{ prix | money_without_trailing_zeros }} TND » : le « TND » écrit après le montant est retiré.
      var n = el.nextSibling;
      if (n && n.nodeType === 3 && /^[   ]?TND\b/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/^[   ]?TND\b/, '');
    }
    function texte(node) {
      var v = node.nodeValue;
      var p = node.parentNode;
      if (p && p.nodeName === 'CR-PRIX') { prix(p); return; }
      if (!v || !/TND|dinar/i.test(v)) return;
      if (!p || IGN.test(p.nodeName) || (p.closest && p.closest('[data-cr-skip]'))) return;
      var nv = convertText(sansMinimumTexte(v), MK); // Q-12 : minimum tunisien retiré avant conversion
      if (nv !== v) node.nodeValue = nv;
    }
    function attrs(el) {
      ['title', 'aria-label'].forEach(function (a) {
        var v = el.getAttribute(a);
        if (!v || !/TND|dinar/i.test(v)) return;
        var nv = convertText(sansMinimumTexte(v), MK);
        if (nv !== v) el.setAttribute(a, nv);
      });
    }
    function balayer(r) {
      if (!r) return;
      if (r.nodeType === 3) { texte(r); return; }
      if (r.nodeType !== 1 && r.nodeType !== 9 && r.nodeType !== 11) return;
      if (r.nodeType === 1) {
        if (IGN.test(r.nodeName)) return;
        if (r.nodeName === 'CR-PRIX') prix(r);
        attrs(r);
      }
      var q = r.querySelectorAll ? r.querySelectorAll('cr-prix') : [];
      for (var i = 0; i < q.length; i++) prix(q[i]);
      var q2 = r.querySelectorAll ? r.querySelectorAll('[title*="TND"],[title*="dinar"],[aria-label*="TND"],[aria-label*="dinar"]') : [];
      for (var j = 0; j < q2.length; j++) attrs(q2[j]);
      var w = document.createTreeWalker(r, 4, null), t;
      while ((t = w.nextNode())) texte(t);
    }
    // Q-12 (Alaa 03/11 22:58) : le minimum de paiement en argent ne vaut qu'en Tunisie. Blocs d'achat en pack
    // (crea-pack-achat, crea-pack-offre) : seuil remis à 0 puis recalcul par le thème (window.creaPackMaj) ; minPack ne
    // désactive alors plus le bouton et masque son message. Phrases et bandeau du minimum : masqués par le CSS du <head>.
    function sansMinimum(r) {
      if (!r || r.nodeType !== 1) return;
      var q = [].slice.call(r.querySelectorAll('[data-pa-seuil]'));
      if (r.hasAttribute('data-pa-seuil')) q.push(r);
      q.forEach(function (box) {
        if (box.getAttribute('data-pa-seuil') === '0') return;
        box.setAttribute('data-pa-seuil', '0');
        try { if (typeof root.creaPackMaj === 'function') root.creaPackMaj(box); } catch (e) {}
      });
    }
    balayer(document.body);
    sansMinimum(document.body);
    pret();
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === 'characterData') texte(m.target);
        else if (m.type === 'attributes' && m.attributeName === 'data-cr-m') prix(m.target);
        else if (m.type === 'attributes') attrs(m.target);
        else for (var i = 0; i < m.addedNodes.length; i++) { balayer(m.addedNodes[i]); sansMinimum(m.addedNodes[i]); }
      });
      ctas();
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['title', 'aria-label', 'data-cr-m'] });

    // ---------- boutons de paiement hors Tunisie (panier latéral et page panier) ----------
    function bloc(fromCart) {
      var w = document.createElement('div');
      w.className = 'cr-mk-ctas';
      w.setAttribute('data-cr-skip', '');
      var c = document.createElement(CFG.ls ? 'a' : 'button');
      c.className = 'cr-mk-btn';
      if (CFG.ls) { c.href = '#'; c.setAttribute('data-cr-mk-carte', ''); c.textContent = T.carte; }
      else { c.type = 'button'; c.disabled = true; c.innerHTML = '<span></span> <small></small>'; c.firstChild.textContent = T.carte; c.lastChild.textContent = '· ' + T.bientot; }
      w.appendChild(c);
      if (CFG.wh) {
        var v = document.createElement('button');
        v.type = 'button'; v.className = 'cr-mk-btn cr-mk-btn--alt'; v.setAttribute('data-cr-mk-vir', ''); v.textContent = T.vir;
        w.appendChild(v);
      }
      if (fromCart) w.setAttribute('data-cr-mk-panier', '');
      return w;
    }
    function ctas() {
      var zs = document.querySelectorAll('.cart__ctas');
      for (var i = 0; i < zs.length; i++) {
        var z = zs[i];
        var b = z.querySelector(':scope > .cr-mk-ctas');
        if (!b) { b = bloc(true); z.appendChild(b); }
        var co = z.querySelector('#checkout, .cart__checkout-button');
        // Q-12 : hors TN, pas de minimum ; seul un panier vide désactive (data-crea-min = minimum tunisien, ignoré).
        var off = !!(co && co.disabled && !co.hasAttribute('data-crea-min'));
        b.querySelectorAll('[data-cr-mk-vir],[data-cr-mk-carte]').forEach(function (x) {
          if (x.tagName === 'BUTTON') { if (x.disabled !== off) x.disabled = off; }
          else if (x.getAttribute('aria-disabled') !== String(off)) x.setAttribute('aria-disabled', String(off));
          var nt = '';
          if (x.title !== nt) x.title = nt;
        });
      }
    }
    ctas();

    // ---------- fenêtre « Régler votre commande » ----------
    var DLG = null, courant = null, dernierEnvoi = 0;
    function fenetre() {
      if (DLG) return DLG;
      DLG = document.createElement('dialog');
      DLG.className = 'cr-mk-dlg';
      DLG.setAttribute('data-cr-skip', '');
      DLG.setAttribute('aria-labelledby', 'cr-mk-h');
      DLG.innerHTML = '<h2 id="cr-mk-h"></h2><p class="cr-mk-note" data-r></p><p class="cr-mk-note" data-g hidden></p><div data-b></div>' +
        '<form data-f hidden novalidate><label for="cr-mk-mail"></label><input id="cr-mk-mail" type="email" name="email" autocomplete="email" required><p class="cr-mk-note cr-mk-err" data-e role="alert" hidden></p>' +
        '<div class="cr-mk-row"><button type="submit" class="cr-mk-btn" data-go></button></div></form><div class="cr-mk-ins" data-i role="status" hidden></div>' +
        '<p class="cr-mk-note" data-t></p><div class="cr-mk-row"><button type="button" class="cr-mk-btn cr-mk-btn--alt" data-x></button></div>';
      DLG.querySelector('#cr-mk-h').textContent = T.titre;
      DLG.querySelector('label').textContent = T.mail;
      DLG.querySelector('[data-go]').textContent = T.envoyer;
      DLG.querySelector('[data-x]').textContent = T.annuler;
      DLG.querySelector('[data-t]').textContent = T.tokens;
      DLG.querySelector('[data-g]').textContent = T.gratuit;
      DLG.addEventListener('click', function (e) {
        if (e.target === DLG || e.target.closest('[data-x]')) DLG.close();
        else if (e.target.closest('[data-cr-mk-vir]')) { DLG.querySelector('[data-f]').hidden = false; DLG.querySelector('#cr-mk-mail').focus(); }
        else if (e.target.closest('[data-cr-mk-carte]')) { e.preventDefault(); carte(); }
      });
      DLG.querySelector('[data-f]').addEventListener('submit', function (e) { e.preventDefault(); virement(); });
      document.body.appendChild(DLG);
      return DLG;
    }
    function lirePanier() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }
    function ouvrir(items, total, gratuit) {
      var D = fenetre();
      courant = { items: items || null, total: total };
      D.querySelector('[data-g]').hidden = !gratuit;
      D.querySelector('[data-b]').hidden = !!gratuit;
      D.querySelector('[data-b]').innerHTML = '';
      D.querySelector('[data-b]').appendChild(bloc(false));
      D.querySelector('[data-f]').hidden = true;
      D.querySelector('[data-e]').hidden = true;
      D.querySelector('[data-i]').hidden = true;
      D.querySelector('[data-go]').disabled = false;
      var r = D.querySelector('[data-r]');
      r.textContent = '';
      var fin = function () {
        var n = courant.items ? courant.items.reduce(function (s, x) { return s + x.quantity; }, 0) : 0;
        r.textContent = n ? (n + (L ? (n > 1 ? ' items' : ' item') : (n > 1 ? ' articles' : ' article')) + (courant.total != null ? ' · ' + format(courant.total / CFG.u, MK.currency, MK.lang) : '')) : '';
      };
      if (!courant.items) {
        courant.p = lirePanier().then(function (c) {
          courant.items = (c.items || []).map(function (x) { return { variant_id: String(x.variant_id), quantity: x.quantity }; });
          courant.total = c.total_price;
          fin();
        }).catch(function () { courant.items = []; fin(); });
      } else { courant.p = Promise.resolve(); fin(); }
      if (!D.open) D.showModal();
    }
    function carte() {
      if (!CFG.ls || !courant) return;
      // [HYP] Lemon Squeezy : données transmises en checkout[custom][…] (à valider à l'intégration, chantier 3).
      courant.p.then(function () { try {
        var u = new URL(CFG.ls, location.href);
        var it = (courant.items || []).map(function (x) { return x.variant_id + ':' + x.quantity; }).join(',');
        u.searchParams.set('checkout[custom][market]', MK.country);
        u.searchParams.set('checkout[custom][variant_ids]', it);
        if ((courant.items || []).length) location.href = u.toString();
      } catch (e) {} });
    }
    function virement() {
      var D = DLG, f = D.querySelector('[data-f]'), em = D.querySelector('#cr-mk-mail'), er = D.querySelector('[data-e]'), go = D.querySelector('[data-go]'), ins = D.querySelector('[data-i]');
      var email = String(em.value || '').trim();
      er.hidden = true;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { er.textContent = T.e400; er.hidden = false; em.focus(); return; }
      if (Date.now() - dernierEnvoi < 20000) { er.textContent = T.attendre; er.hidden = false; return; }
      go.disabled = true; go.setAttribute('aria-busy', 'true');
      courant.p.then(function () {
      var items = (courant && courant.items) || [];
      if (!items.length) { go.disabled = false; go.removeAttribute('aria-busy'); er.textContent = T.e400; er.hidden = false; return; }
      dernierEnvoi = Date.now();
      return fetch(CFG.wh, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ market: MK.country, currency: MK.currency, email: email, items: items, locale: MK.lang })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { return { s: r.status, j: j || {} }; });
      }).then(function (x) {
        go.removeAttribute('aria-busy');
        if (x.s >= 200 && x.s < 300 && x.j.ok !== false) {
          f.hidden = true;
          ins.textContent = x.j.instructions ? String(x.j.instructions) : T.ok;
          ins.hidden = false;
          return;
        }
        go.disabled = false;
        var m = T.eres;
        if (x.s === 400) m = (x.j.error === 'variante_inconnue' || x.j.error === 'prix_nul') ? T.e400v : T.e400;
        else if (x.s === 503) m = T.e503;
        else if (x.s === 502) m = T.e502;
        er.textContent = m; er.hidden = false;
      }).catch(function () {
        go.disabled = false; go.removeAttribute('aria-busy');
        er.textContent = T.eres; er.hidden = false;
      });
      });
    }

    // ---------- accès au checkout interceptés (capture, avant les scripts du thème) ----------
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var b = t.closest('[data-cr-mk-vir],[data-cr-mk-carte]');
      if (b && b.closest('[data-cr-mk-panier]')) {
        e.preventDefault();
        if (b.disabled || b.getAttribute('aria-disabled') === 'true') return;
        ouvrir(null);
        if (b.hasAttribute('data-cr-mk-vir')) DLG.querySelector('[data-f]').hidden = false;
        else carte();
        return;
      }
      var rc = t.closest('[data-rc-v]');
      if (rc) { e.preventDefault(); e.stopImmediatePropagation(); try { rc.closest('dialog').close(); } catch (er) {} ouvrir([{ variant_id: String(rc.getAttribute('data-rc-v')), quantity: 1 }]); return; }
      var a = t.closest('a[href]');
      if (a && a.host === location.host) {
        var it = itemsFromPermalink(a.pathname);
        if (it || /^\/checkouts?(\/|$)/.test(a.pathname)) {
          e.preventDefault(); e.stopImmediatePropagation();
          try { var dg = a.closest('dialog'); if (dg && dg !== DLG) dg.close(); } catch (er) {}
          // Lien gratuit (/cart/<id>:1?discount=…, bloc « 100 % gratuit ») : pas de paiement, pas de checkout hors Tunisie.
          ouvrir(it, null, /[?&]discount=/.test(a.search) || !!a.closest('.cr-free-cta'));
        }
      }
    }, true);
    root.addEventListener('submit', function (e) {
      var f = e.target;
      if (!(f instanceof HTMLFormElement)) return;
      var sb = e.submitter;
      var act = (f.getAttribute('action') || '').split('?')[0];
      var rt = f.querySelector('[name="return_to"]');
      var versCheckout = (sb && sb.name === 'checkout') || /\/checkout/.test(act) || (rt && /checkout/.test(rt.value || ''));
      if (!versCheckout) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var id = f.querySelector('[name="id"]');
      if (/\/cart\/add/.test(act) && id) ouvrir([{ variant_id: String(id.value), quantity: Number((f.querySelector('[name="quantity"]') || {}).value) || 1 }]);
      else ouvrir(null);
    }, true);

    // ---------- pays : fenêtre d'accueil (1er passage) et lien du pied de page ----------
    function choisirPays(premier) {
      var D = document.createElement('dialog');
      D.className = 'cr-mk-dlg';
      D.setAttribute('data-cr-skip', '');
      D.setAttribute('aria-labelledby', 'cr-mk-ph');
      var liste = ['TN'].concat(EUR, ['QA', 'SA', 'AE', 'US']);
      if (liste.indexOf(MK.country) < 0 && MK.country !== 'ZZ') liste.push(MK.country);
      var opts = liste.map(function (c) { return { c: c, n: nomPays(c) }; });
      opts.sort(function (x, y) { return x.n.localeCompare(y.n, MK.lang); });
      opts.push({ c: 'ZZ', n: T.autre + ' (USD)' });
      D.innerHTML = '<h2 id="cr-mk-ph"></h2><p class="cr-mk-note" data-p></p><div data-c><label for="cr-mk-pays"></label><select id="cr-mk-pays"></select></div><div class="cr-mk-row"><button type="button" class="cr-mk-btn" data-ok></button></div>';
      D.querySelector('h2').textContent = premier ? T.accueil : T.pays;
      D.querySelector('[data-p]').textContent = T.detecte + ' ' + nomPays(MK.country) + ' · ' + T.prix + ' ' + MK.currency + '.';
      D.querySelector('label').textContent = premier ? T.changer : T.pays;
      var sel = D.querySelector('select');
      opts.forEach(function (o) { var op = document.createElement('option'); op.value = o.c; op.textContent = o.n; if (o.c === MK.country) op.selected = true; sel.appendChild(op); });
      D.querySelector('[data-ok]').textContent = premier ? T.confirmer : T.valider;
      sel.addEventListener('change', function () { D.querySelector('[data-ok]').textContent = T.valider; });
      D.querySelector('[data-ok]').addEventListener('click', function () {
        var c = sel.value;
        if (ST) writeStore(ST, c); // seul enregistrement : choix explicite
        try { root.sessionStorage.removeItem(KEY); } catch (e) {} // le choix remplace un ?cr-market= de recette
        D.close();
        if (c !== MK.country) location.reload();
      });
      // Échap / fermeture : rien n'est enregistré (la fenêtre reviendra au prochain passage).
      document.body.appendChild(D);
      D.showModal();
    }
    var pied = document.querySelector('.footer-utilities__group--left') || document.querySelector('footer') || document.querySelector('.shopify-section-group-footer-group:last-of-type');
    if (pied) {
      var p = document.createElement('p');
      p.className = 'cr-mk-foot';
      p.setAttribute('data-cr-skip', '');
      var bt = document.createElement('button');
      bt.type = 'button';
      bt.textContent = T.pays + ' : ' + nomPays(MK.country) + ' · ' + MK.currency + ' — ' + T.modif;
      bt.addEventListener('click', function () { choisirPays(false); });
      p.appendChild(bt);
      pied.appendChild(p);
    }
    if (!CFG.ed && ST && !readStore(ST) && src !== 'param' && !dejaVu()) choisirPays(true);
    function dejaVu() {
      // une seule apparition par session de navigation tant qu'aucun choix n'est confirmé (rien en localStorage)
      try { if (root.sessionStorage.getItem(KEY + '-vu')) return true; root.sessionStorage.setItem(KEY + '-vu', '1'); } catch (e) {}
      return false;
    }
  }
})(typeof window !== 'undefined' ? window : this);